import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define valid status types
type SessionStatus = 'active' | 'completed' | 'pending' | null;

interface SessionPayload {
  session_id: string | null;
  user_id: string | null;
  status: SessionStatus;
  classification: string | null;
  question_count: number;
  interview_ended: boolean;
  created_at: string | null;
  updated_at: string | null;
}

interface SessionState {
  sessionId: string | null;
  userId: string | null;
  status: SessionStatus;
  jobType: string | null;
  classification: string | null;
  questionCount: number;
  interviewEnded: boolean;
  createdAt: string | null;
  updatedAt: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: SessionState = {
  sessionId: null,
  userId: null,
  status: null,
  jobType: null,
  classification: null,
  questionCount: 0,
  interviewEnded: false,
  createdAt: null,
  updatedAt: null,
  isLoading: false,
  error: null
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionPayload>) => {
      const { session_id, user_id, status, classification, question_count, interview_ended, created_at, updated_at } = action.payload
      state.sessionId = session_id
      state.userId = user_id
      state.status = status
      state.classification = classification
      state.jobType = classification
      state.questionCount = question_count
      state.interviewEnded = interview_ended
      state.createdAt = created_at
      state.updatedAt = updated_at
    },
    updateStatus: (state, action: PayloadAction<SessionStatus>) => {
      state.status = action.payload
    },
    incrementQuestions: (state) => {
      state.questionCount += 1
    },
    endInterview: (state) => {
      state.interviewEnded = true
      state.status = 'completed'
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    clearSession: (state) => {
      Object.assign(state, initialState)
    }
  }
})

export const {
  setSession,
  updateStatus,
  incrementQuestions,
  endInterview,
  setLoading,
  setError,
  clearSession
} = sessionSlice.actions

export default sessionSlice.reducer
